<template>logoPath
      <div class="header-recibo nao-imprimir">
        <h2 class="titulo-pagina">Recibo</h2>
        <div class="botoes">
          <b-button variant="secondary" class="btn-voltar" @click="voltar">
            <i class="bi bi-arrow-left"></i> Voltar
          </b-button>
          <b-button
            v-if="podeEmitirRecibo && reciboCarregado"
            :variant="isDownloading ? 'success' : 'danger'"
            class="btn-pdf"
            :disabled="isDownloading || !reciboCarregado"
            @click="gerarPDF"
          >
            <i class="bi bi-file-earmark-pdf"></i>
            {{ isDownloading ? 'Baixando' : 'Baixar' }}
          </b-button>
        </div>
      </div>
  
      <p v-if="erroRecibo" role="alert" class="alert alert-danger nao-imprimir">{{ erroRecibo }}</p>
      <!-- Área de impressão -->
      <div v-if="podeEmitirRecibo && reciboCarregado" ref="reciboContent" class="recibo-container print-area">
        <div class="recibo-container">
            <div class="recibo">
              <!-- Cabeçalho -->
              <div class="recibo-header">
                <img
                  v-if="$globalState.logoPath"
                  :src="$globalState.logoPath"
                  alt="Logomarca"
                  class="header-logo"
                />
              <div class="escola-info">
                <h4>{{ escola.razao_social }}</h4><p></p>
                
                {{ escola.slogan }}<p></p>

                <p>
                    {{ escola.endereco }}, {{ escola.numero }} 
                    <span v-if="escola.complemento && escola.complemento !== 'null'">, {{ escola.complemento }}</span>
                    - {{ escola.bairro }}
                </p>
                <p>{{ escola.municipio_nome }} - {{ escola.estado_sigla }}, CEP: {{ escola.cep }}</p>
                <p>
                  <i class="bi bi-telephone"></i> {{ escola.telefone1 }} 
                  <i class="bi bi-whatsapp text-success"></i> {{ escola.telefone2 }}
                </p>
              </div>
            </div>
    
            <!-- Título -->
            <h3 class="recibo-title">RECIBO</h3>
    
            <!-- Dados do Cliente e Pagamento -->
            <table class="info-table">
              <colgroup>
                <col style="width: 25%;">
                <col style="width: 75%;">
              </colgroup>
              <tbody>
              <tr>
                  <td>Cliente:</td>
                  <td><strong>{{ recibo.cliente_nome }}</strong></td>
              </tr>
              <tr>
                  <td>Data da Venda:</td>
                  <td>{{ formatarData(recibo.data_venda) }}</td>
              </tr>
              </tbody>
            </table>
    
            <!-- Texto de recebimento -->
            <p class="recibo-texto">
                Recebemos de <strong>{{ recibo.cliente_nome }}</strong> a importância
                de <strong>{{ formatarValor(recibo.valor_total) }}</strong> (
                {{ extenso(recibo.valor_total) }} ), referente aos itens descritos
                abaixo:
            </p>
    
            <!-- Tabela de Itens -->
            <table class="aula-table">
              <colgroup>
                <col style="width: 15%;">
                <col style="width: 35%;">
                <col style="width: 10%;">
                <col style="width: 20%;">
                <col style="width: 20%;">
              </colgroup>

                <thead>
                <tr>
                    <th>Código</th>
                    <th>Produto</th>
                    <th>Quantidade</th>
                    <th>Valor Unitário</th>
                    <th>Subtotal</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in recibo.itens" :key="i">
                    <td>{{ item.codigo }}</td>
                    <td>{{ item.produto }}</td>
                    <td>{{ item.quantidade }}</td>
                    <td>{{ formatarValor(item.preco_unitario) }}</td>
                    <td>{{ formatarValor(item.subtotal) }}</td>
                </tr>
                </tbody>
            </table>

            <!-- Seção de Pagamentos -->
            <table class="table table-bordered">
                <thead class="table-light">
                <tr>
                    <th>#</th>
                    <th>Forma de Pagamento</th>
                    <th>Vencimento</th>
                    <th>Valor</th>
                    <th>Pagamento</th>
                    <th v-if="recibo.pagamentos.some(p => p.banco_numero)">Banco</th>
                    <th v-if="recibo.pagamentos.some(p => p.agencia)">Agência</th>
                    <th v-if="recibo.pagamentos.some(p => p.cheque_numero)">Cheque nº</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(p, i) in recibo.pagamentos" :key="p.id">
                    <td>{{ i + 1 }}</td>
                    <td>{{ p.forma_pagamento }}</td>
                    <td>{{ p.data_vencimento ? formatarData(p.data_vencimento) : '-' }}</td>
                    <td>{{ formatarValor(p.valor) }}</td>
                    <td>{{ p.data_pagamento ? formatarData(p.data_pagamento) : '-' }}</td>
                    <td v-if="p.banco_numero">{{ p.banco_numero }}</td>
                    <td v-if="p.agencia">{{ p.agencia }}</td>
                    <td v-if="p.cheque_numero">{{ p.cheque_numero }}</td>
                </tr>
                </tbody>
            </table>

    
            <!-- Observações fixas -->
            <div class="observacoes">
                <h4>OBSERVAÇÕES IMPORTANTES:</h4>
                <ol>
                <li>
                  O PAGAMENTO EFETIVADO EM CHEQUE(S) E/OU BOLETO(S) SÓ VALIDARÁ O PRESENTE RECIBO APÓS A(S) DEVIDA(S)
                  COMPENSAÇÃO(ÕES).
                </li>
                <li>
                    ESTE RECIBO SUBSTITUI OUTROS QUE PORVENTURA TENHAM SIDO
                    GERADOS ANTERIORMENTE.
                </li>
                </ol>
            </div>
    
            <!-- Rodapé e assinaturas -->
            <div class="assinatura-container">
              <p class="texto-final">
              Por ser verdade, firmamos o presente recibo em duas vias de igual
              teor e conteúdo.
              </p>
              <p class="data-local">
              {{ escola.municipio_nome }} – {{ escola.estado_sigla }},
              {{ formatarDataAtual() }}
              </p>
              <div class="assinaturas">
                <!-- Via Escola -->
                <div class="assinatura">
                    <hr />
                    <p></p>
                    <p>{{ escola.razao_social }}</p>
                    <p>CNPJ: {{ formatarCNPJ(escola.cnpj) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
     </div>
  </template>
  
  <script>
  import { BButton } from 'bootstrap-vue-next';
  import jsPDF from 'jspdf';
  import html2canvas from 'html2canvas';
  import globalUtils from '@/utils/globalUtils.js';
  import axios from '@/services/axios';
  import { useReceitasPermissions } from '@/composables/useReceitasPermissions';
  
  export default {
    name: 'ReciboVenda',
    components: { BButton },
    setup() {
      return useReceitasPermissions();
    },
    props: {
      id: {
        type: [String, Number],
        required: true
      }
    },
    data() {
      return {
        isDownloading: false,
        reciboCarregado: false,
        erroRecibo: '',
        recibo: {
          itens: [],
          pagamentos: [],
        },
        escola: {}
      };
    },
    computed: {
      podeEmitirRecibo() {
        return this.hasPermission('emitir_recibo_vendas');
      },
      utils() {
        return globalUtils;
      }
    },
    methods: {
      async carregarRecibo() {
        this.reciboCarregado = false;
        this.erroRecibo = '';
        this.recibo = { itens: [], pagamentos: [] };
        if (!(await this.authorizeReceiptAction('emitir_recibo_vendas'))) {
          this.erroRecibo = this.permissionsError || 'Você não possui permissão para emitir recibos de venda.';
          return false;
        }
        try {
          // endpoint que retorna tudo: venda + cliente + itens + forma, etc.
          const response = await axios.get(`/loja/vendas/${this.id}/recibo`);
          this.recibo = response.data;
          this.reciboCarregado = true;
          return true;
        } catch (err) {
          this.erroRecibo = err.response?.status === 403
            ? 'Você não possui permissão para emitir recibos de venda.'
            : 'Não foi possível carregar o recibo. Reabra a página para tentar novamente.';
          return false;
        }
      },
      formatarData(iso) {
        return this.utils.formatarData(iso);
      },
      formatarDataAtual() {
        return new Date().toLocaleDateString('pt-BR');
      },
      formatarValor(val) {
        return this.utils.formatarValor(val);
      },
      extenso(val) {
        const num = Number(val);
        return this.utils.valorPorExtenso(num);
      },
      formatarCPF(cpf) {
        return this.utils.formatarCPF(cpf);
      },
      formatarCNPJ(cnpj) {
        return this.utils.formatarCNPJ(cnpj);
      },
      async gerarPDF() {
        if (this.isDownloading || !this.reciboCarregado || !this.podeEmitirRecibo) return;
        this.isDownloading = true;
        try {
          // Revalida no backend antes de gerar o documento, inclusive após revogação.
          if (!(await this.carregarRecibo())) return;
          await this.$nextTick();
          const element = this.$refs.reciboContent;
          const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true
          });
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          const imgWidth = 210;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          pdf.addImage(imgData, 'PNG', 0, 10, imgWidth, imgHeight);
          pdf.save(`recibo-venda-${this.recibo.cliente_nome}.pdf`);
        } catch (err) {
          console.error('Erro ao gerar PDF:', err);
        } finally {
          this.isDownloading = false;
        }
      },
      voltar() {
        this.$router.back();
      }
    },
    async mounted() {
      if (!(await this.carregarRecibo())) return;
      // buscar dados da empresa/configurações, se necessário
      try {
        const { data } = await axios.get('/configuracoes/empresa');
        this.escola = data;
      } catch {
        this.reciboCarregado = false;
        this.erroRecibo = 'Não foi possível carregar os dados da escola. Reabra a página para tentar novamente.';
      }
    }
  };
  </script>
  
  <style scoped>
  /* Copie aqui todos os estilos de ImprimirRecibo.vue (header-recibo, botoes, recibo-container, etc.) */
  .header-recibo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
  }
  .titulo-pagina {
    font-size: 20px;
    font-weight: bold;
    color: #444;
  }
  .botoes {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .btn-voltar,
  .btn-pdf {
    width: 80px;
    height: 30px;
    font-size: 12px;
    padding: 4px 8px;
    white-space: nowrap;    /* impede quebra de linha */

  }
  .recibo-container {
    max-width: 800px;
    margin: auto;
    background: white;
    padding: 20px;
    border: none
  }
  .recibo-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .header-logo {
    height: 60px;
  }
  .escola-info {
    text-align: center;
    margin: 0; /* Remove as margens verticais */
    line-height: 0; /* ✅ Reduz o espaçamento entre as linhas */
    font-size: 12px; /* ✅ Ajusta o tamanho da fonte */
  }
  .recibo-title {
    text-align: center;
    margin: 30px 0;
    font-size: 20px;
    font-weight: bold;
  }
  .info-table,
  .aula-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  .info-table td,
  .aula-table th,
  .aula-table td {
    border: 1px solid #ddd;
    padding: 8px;
  }
  .aula-table th {
    background-color: #f2f2f2;
  }
  .observacoes {
    background: #f8f9fa;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 11px;
    margin-bottom: 30px;
  }
  .observacoes h4 {
    font-size: 11px;
    margin-bottom: 10px;
  }
  .assinatura-container {
    text-align: center;
  }
  .data-local {
    margin: 10px 0;
  }
  .assinaturas {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
  }
  .assinatura {
    width: 45%;
    text-align: center;
    margin-top: 40px;
    line-height: 0;
  }
  .assinatura hr {
    margin-bottom: 5px;
    border-top: 1px solid #000;
  }
  </style>
  